"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrecisionScaler = exports.getMedian = exports.calculateDeviationPercent = exports.calculateSum = exports.castToISafeNumber = void 0;
const decimal_js_1 = __importDefault(require("decimal.js"));
const ISafeNumberMath = __importStar(require("../ISafeNumber"));
const ISafeNumber_1 = require("../ISafeNumber");
const castToISafeNumber = (numberLike) => {
    if (typeof numberLike === "string" || typeof numberLike === "number") {
        return (0, ISafeNumber_1.createSafeNumber)(numberLike.toString());
    }
    else if (numberLike instanceof decimal_js_1.default) {
        return (0, ISafeNumber_1.createSafeNumber)(numberLike.toString());
    }
    else if (numberLike.isSafeNumber()) {
        return numberLike;
    }
    else {
        throw new Error(`Can not cast ${numberLike} to ISafeNumber`);
    }
};
exports.castToISafeNumber = castToISafeNumber;
const calculateSum = (numbers) => ISafeNumberMath.calculateSum(numbers.map(exports.castToISafeNumber)).unsafeToNumber();
exports.calculateSum = calculateSum;
const calculateDeviationPercent = (args) => ISafeNumberMath.calculateDeviationPercent({
    prevValue: (0, exports.castToISafeNumber)(args.prevValue),
    currValue: (0, exports.castToISafeNumber)(args.newValue),
}).unsafeToNumber();
exports.calculateDeviationPercent = calculateDeviationPercent;
const getMedian = (numbers) => ISafeNumberMath.getMedian(numbers.map(exports.castToISafeNumber)).unsafeToNumber();
exports.getMedian = getMedian;
class PrecisionScaler {
    constructor(tokenDecimals) {
        this.tokenDecimals = tokenDecimals;
        this.tokenDecimalsScaler = new decimal_js_1.default(10).pow(tokenDecimals);
    }
    toSolidityValue(floatNumber) {
        return new decimal_js_1.default(floatNumber).mul(this.tokenDecimalsScaler).toString();
    }
    fromSolidityValue(contractValue) {
        return new decimal_js_1.default(contractValue.toString()).div(this.tokenDecimalsScaler);
    }
}
exports.PrecisionScaler = PrecisionScaler;
//# sourceMappingURL=index.js.map